import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"
import LinearProgress from "@mui/material/LinearProgress"
import { useLocale } from "next-intl"
import { FailIcon, FileProgressIcon, NewText, SuccessIcon } from "ui"
import { StyledContent } from "../styles/FileDeliveryStyles"

type DownloadProgressDialogProps = {
  open: boolean
  onClose: () => void
  downloadProgress: {
    progress: number
    success?: string
  }
  selectedCount: number
  totalFiles: number
  messages: any
  fileCategory?: any
  fileName?: string
}

const StyledDialog = styled(Dialog)`
  border-radius: 16px;
  ${(props) => props.theme.breakpoints.down("md")} {
    max-width: 100%;
    bottom: 0px;
    .MuiDialog-container {
      align-items: flex-end;
      width: 100%;
    }
    .MuiPaper-root {
      margin: 0px;
      width: 100%;
    }
  }
`

const DownloadProgressDialog = ({
  open,
  onClose,
  downloadProgress,
  selectedCount,
  totalFiles,
  messages,
  fileCategory,
  fileName,
}: DownloadProgressDialogProps) => {
  const locale = useLocale()

  const getDownloadingText = () => {
    const fileCount = selectedCount > 0 ? selectedCount : totalFiles

    if (fileCount === 1 && fileName) {
      return locale === "he" ? (
        <>
          מוריד קובץ <strong>״{fileName}״</strong>
        </>
      ) : (
        <>
          Downloading file <strong>&ldquo;{fileName}&rdquo;</strong>
        </>
      )
    }

    if (fileCategory) {
      return locale === "he" ? (
        <>
          מורידים <strong>{fileCount}</strong> קבצים בקטגוריה <strong>״{fileCategory}״</strong>
        </>
      ) : (
        <>
          Downloading <strong>{fileCount}</strong> files in category{" "}
          <strong>&ldquo;{fileCategory}&rdquo;</strong>
        </>
      )
    }

    return locale === "he" ? (
      <>
        מורידים <strong>{fileCount}</strong>
        <strong> קבצים</strong> שנבחרו
      </>
    ) : (
      <>
        Downloading <strong>{fileCount}</strong> <strong>selected</strong> files
      </>
    )
  }

  const renderProgressContent = () => {
    if (downloadProgress.progress <= 100) {
      return (
        <>
          <FileProgressIcon />
          <NewText component={"p"} desktopFontSize={24} color="#000000">
            {getDownloadingText()}
          </NewText>
          <LinearProgress variant="determinate" value={downloadProgress.progress} />
        </>
      )
    }

    if (downloadProgress.progress === 100 && downloadProgress.success === "successed") {
      return (
        <>
          <SuccessIcon />
          <NewText component={"p"} desktopFontSize={24} color="#000000">
            {messages.successTitle}
          </NewText>
          <NewText component={"p"} desktopFontSize={18} color="#000000">
            {messages.successText}
          </NewText>
        </>
      )
    }

    if (downloadProgress.progress === 100 && downloadProgress.success === "failed") {
      return (
        <>
          <FailIcon />
          <NewText component={"p"} desktopFontSize={24} color="#000000">
            {messages.failTitle}
          </NewText>
          <NewText component={"p"} desktopFontSize={18} color="#000000">
            {messages.failText}
          </NewText>
        </>
      )
    }

    return null
  }

  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledContent>{renderProgressContent()}</StyledContent>
    </StyledDialog>
  )
}

export default DownloadProgressDialog
